import { InsuranceFundConsumer } from '@injectivelabs/exchange-consumer'
import { app } from './App'

export const insuranceFundConsumer = new InsuranceFundConsumer(
  app.appUrlEndpoint.exchangeUrl
)
